import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { MdOutlineAdd } from "react-icons/md";
import { FaPencil } from "react-icons/fa6";
import "./note.css";

const Notes = () => {
  const [showModal, setShowModal] = useState(false);
  const [, setIsFormVisible] = useState(false);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");

  const handleAddClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNewNote("");
  };

  const handleSaveClick = () => {
    setIsFormVisible(false);
    alert("Provider details saved successfully!");
  };

  const handleSaveNote = () => {
    if (newNote.trim() !== "") {
      const noteObject = {
        id: Date.now(),
        text: newNote.trim(),
        author: "Admin SM",
        timestamp: new Date().toLocaleString(),
      };

      setNotes((prevNotes) => [...prevNotes, noteObject]);
      setNewNote("");
      setShowModal(false);
    } else {
      alert("Note cannot be empty!");
    }
  };

  const handleDeleteNote = (id) => {
    setNotes((prevNotes) =>
      prevNotes.filter((note) => note.id !== id)
    );
  };

  return (
    <div className="notes-main-container">

      <h5
        className="notes-heading"
        style={{
          backgroundColor: "white",
          color: "#004aad",
          padding: "5px",
          fontWeight: "bold",
          fontSize: "24px",
        }}
      >
        Notes
      </h5>

      <div
        className="notes-form-box"
        style={{
          alignItems: "center",
          fontSize: "0.9rem",
          marginRight: "20px",
          backgroundColor: "#f2f2f2",
          border: "1px solid #ccc",
          padding: "10px",
          borderTop: "3px solid #004aad",
        }}
      >
        <br />

        <div
          className="notes-field-row"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <strong
            className="notes-label"
            style={{
              marginLeft: "10px",
            }}
          >
            External ID
          </strong>

          <Form.Control
            type="text"
            placeholder=""
            className="notes-input external-id-input"
            style={{
              width: "160px",
              height: "35px",
              fontSize: "0.9rem",
              padding: "0.5rem",
              marginLeft: "125px",
            }}
          />
        </div>

        <br />

        <div
          className="notes-field-row"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <strong
            className="notes-label"
            style={{
              marginLeft: "10px",
            }}
          >
            Regional Customer ID
          </strong>

          <Form.Control
            type="text"
            placeholder=""
            className="notes-input regional-id-input"
            style={{
              width: "160px",
              height: "35px",
              fontSize: "0.9rem",
              padding: "0.5rem",
              marginLeft: "50px",
            }}
          />
        </div>

        <br />
      </div>

      <br />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <button
          type="button"
          onClick={handleAddClick}
          className="add-note-button"
          style={{
            backgroundColor: "#004aad",
            color: "white",
            border: "none",
            padding: "8px 12px",
            fontSize: "14px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            borderRadius: "4px",
            marginBottom: "10px",
            marginRight: "15px",
          }}
        >
          <MdOutlineAdd
            size={18}
            style={{
              marginRight: "5px",
            }}
          />
          Add Note
        </button>
      </div>

      <div>
        {notes.map((note) => (
          <div
            key={note.id}
            className="note-item"
            style={{
              backgroundColor: "#fff",
              padding: "10px",
              margin: "10px 0",
              border: "1px solid #ccc",
              borderRadius: "4px",
              position: "relative",
            }}
          >
            <strong className="note-author">
              {note.author}
            </strong>

            <br />

            <em
              className="note-time"
              style={{
                fontSize: "0.8rem",
                color: "gray",
              }}
            >
              {note.timestamp}
            </em>

            <p className="note-text">
              {note.text}
            </p>

            <button
              type="button"
              onClick={() => handleDeleteNote(note.id)}
              className="delete-note-button"
              style={{
                backgroundColor: "red",
                color: "white",
                border: "none",
                padding: "5px 8px",
                fontSize: "12px",
                cursor: "pointer",
                position: "absolute",
                top: "10px",
                right: "10px",
                borderRadius: "4px",
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="lg"
        dialogClassName="custom-modal"
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#004aad",
            color: "white",
            fontWeight: "bold",
            fontSize: "18px",
          }}
        >
          <Modal.Title>
            Account Note
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            height: "300px",
            overflowY: "auto",
            padding: "15px",
          }}
        >
          <Form.Control
            as="textarea"
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            className="note-textarea"
            style={{
              width: "100%",
              height: "200px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              resize: "none",
              fontSize: "14px",
            }}
          />
        </Modal.Body>

        <Modal.Footer
          style={{
            justifyContent: "flex-end",
          }}
        >
          <Button
            type="button"
            variant="secondary"
            onClick={handleCloseModal}
            className="modal-action-button"
            style={{
              backgroundColor: "#004aad",
              borderColor: "#004aad",
              padding: "6px 15px",
              fontSize: "14px",
            }}
          >
            Cancel
          </Button>

          <Button
            type="button"
            variant="primary"
            onClick={handleSaveNote}
            className="modal-action-button"
            style={{
              backgroundColor: "#004aad",
              borderColor: "#004aad",
              padding: "6px 15px",
              fontSize: "14px",
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Button
        type="button"
        className="main-save-button"
        style={{
          backgroundColor: "#004aad",
          borderColor: "#004aad",
        }}
        onClick={handleSaveClick}
      >
        <FaPencil
          style={{
            marginRight: "6px",
          }}
        />
        Save
      </Button>

    </div>
  );
};

export default Notes;